module.exports = __webpack_public_path__ + "img/75632.92bdcf1e.svg";